import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroSection() {
  const slide = heroSlides[0];

  return (
    <section className="relative h-[520px] md:h-[680px] w-full overflow-hidden">
      <img
        src={slide.image}
        alt="aiye 品牌形象"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl whitespace-pre-line">
          {slide.title}
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
          {slide.subtitle}
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/smart-solutions"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {slide.cta}
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-semibold text-sm md:text-base hover:bg-white/10 hover:border-white/60 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}